<template>
  <section class="p_gantt_section">
    <div class="p_gantt_bar">
      <input type="button" value="开始" @click="start">
      <input type="button" value="暂停" @click="pause">
      <input type="button" value="导出Excel" @click="exportToExcel">
    </div>
    <div class="p_gantt_box">
      <div class="p_gantt_box_progress">
        <div ref="gantt" class="p_gantt_progress"></div>
        <TaskForm @doDelete="doDelete" :option="option" @doSubmit="doSubmit" @doCancel="doCancel" :form-data="formData"
                  v-if="taskVisible" @closeTaskForm="closeTaskForm"
                  class="p_task_form" v-dialog-drag></TaskForm>
      </div>
    </div>
    <div class="p_progress_modal" v-if="taskVisible"></div>
  </section>
</template>

<script>
  function showTaskEditView(task, option) {
    showAddTask(task, option);
  }

  import 'dhtmlx-gantt/codebase/sources/dhtmlxgantt'
  import 'dhtmlx-gantt/codebase/ext/dhtmlxgantt_marker'
  import '../../assets/gantt_local_cn'
  import TaskForm from "./TaskForm";
  import {
    createLink,
    updateLink,
    delLink,
    taskMinMaxTime,
    getTasks,
    taskActor,
    taskActorGroup,
    updateTask
  } from '../../api/api'
  import '../../assets/gantt_api'
  import "../../../node_modules/dhtmlx-gantt/codebase/dhtmlxgantt.css";

  let range, startTime, endTime, ms, markerId, rangeTime,du,
    addTaskEvent, updateTaskEvent, delTaskEvent, addLinkEvent, updateLinkEvent,
    delLinkEvent, addViewEvent, marketEvent, saveEvent, onTaskDblClick, onBeforeLightbox, onLoadEnd;

  export default {
    name: "Gantt",
    components: {TaskForm},
    props: {
      data: null,
      scheduledId: null,
      proId: null,
      modelId: null,
    },
    data() {
      return {
        auto: null,
        time: 0,//时间数
        n: 0,//天数
        setting: {
          view: {
            showLine: true,
            showIcon: false,
            selectedMulti: true,

          },
          check: {
            enable: true
          },
          data: {
            simpleData: {
              enable: true,
              idKey: "glid",
              pIdKey: "pglid",
              rootPId: 0
            }
          },
          callback: {
            beforeClick: function (treeId, treeNode) {
              return false;
            },
            onCheck: this.actorCheck,
          }
        },
        zNodes: [
          {id: 1, pId: 0, name: "父节点1"},
          {id: 11, pId: 1, name: "子节点1"},
          {id: 12, pId: 1, name: "子节点2"}
        ],
        taskData: [],
        taskVisible: false,
        dialogTop: '55vh',
        dialogFullScreen: false,
        loadUrl: '',
        option: 0,
        formData: null,
        actors: null,
        voidPause: false,
        voidStart: true,
      }
    },
    methods: {
      //标记线 定时移动
      start: function () {
        if (this.voidStart) {
          if (this.time >= ms) {
            this.time = 0;
            this.n = 0;
          }
          if (this.actors == null) {
            $("#voidLoad").show();
            taskActor({scheduledId: this.scheduledId}, this.GLOBAL.header).then(result => {
              if (result.success) {
                this.actors = result.data;//总构件数据
                range = this.actors.length;
                if (range > 0) {
                  SetModelVisible(this.modelId, false);
                  $("#voidLoad").hide();
                  rangeTime = ms / range;
                  this.auto = setInterval(() => {
                    this.moveMarker();
                  }, 100);
                } else {
                  this.actors = null;
                  $("#voidLoad").hide();
                  this.$message({
                    message: '没有关联的构建',
                    type: 'error'
                  })
                }
              }
            });
          } else {
            if (!this.voidPause) {
              SetModelVisible(this.modelId, false);
            }
            this.auto = setInterval(() => {
              this.moveMarker();
            }, 100);
          }
        }
      },
      //标记线 移动暂停
      pause: function () {
        if (this.time < ms) {
          this.voidPause = true;
        }
        clearInterval(this.auto);
      },
      //移动标记线
      moveMarker: function () {
        // if (this.time < range) {
        //   let actorTime = new Date(this.actors[this.time].startDate);
        //   let current = new Date(actorTime.getFullYear(), actorTime.getMonth(), actorTime.getDate());
        //   SetActorVisible(this.actors[this.time].actorId, true)
        //   gantt.getMarker(markerId).start_date = current;
        //   gantt.updateMarker(markerId);
        //   gantt.scrollTo(this.time, null);
        //   this.time++;
        // } else {
        //   clearInterval(this.auto);
        //   this.voidPause = false;
        //   let lastedTime = new Date(endTime.getFullYear(), endTime.getMonth(), endTime.getDate() + 1);
        //   gantt.getMarker(markerId).start_date = lastedTime;
        //   gantt.updateMarker(markerId);
        //   gantt.scrollTo(this.time + 1, null);
        // }
        let current = new Date(startTime.getFullYear(), startTime.getMonth(), startTime.getDate(), startTime.getHours(),
          startTime.getMinutes(), startTime.getSeconds(), this.time);
        if (this.time < ms) {
          if(this.n<this.actors.length)
          SetActorVisible(this.actors[this.n].actorId, true)
          gantt.getMarker(markerId).start_date = current;
          gantt.updateMarker(markerId);
          gantt.scrollTo(this.n, null);
          this.time = this.time + rangeTime;
          this.n++;
        } else {
          clearInterval(this.auto);
          this.voidPause = false;
          let lastedTime = new Date(endTime.getFullYear(), endTime.getMonth(), endTime.getDate(), endTime.getHours(),
            endTime.getMinutes(), endTime.getSeconds(), endTime.getMilliseconds());
          gantt.getMarker(markerId).start_date = lastedTime;
          gantt.updateMarker(markerId);
          gantt.scrollTo(this.time + rangeTime, null);
        }
      },
      //导出=========================
      //excel
      exportToExcel: function () {
       this.pause();
        gantt.exportToExcel({
          proId: this.proId, comId: null, scheduledId: this.scheduledId, status: 1,
          server: this.GLOBAL.businessServerPath + "/progress/dayexport"
        })
      },
      //=======================================
      //添加/修改/删除 任务视图
      showAddTaskView: function (task, option) {
        clearInterval(this.auto);
        this.option = option;
        this.formData = task;
        this.formData.proId = this.proId;
        this.formData.scheduledId = this.scheduledId;
        ResetAllActor();
        hasSelectionIds = [];
        if (this.option == 1) {

          taskActor({scheduledId: this.scheduledId, taskId: task.id}, this.GLOBAL.header).then(result => {
            if (result.success) {
              for (let i = 0; i < result.data.length; i++) {
                let r = parseInt(selObjectColor.substr(1, 2), 16);
                let g = parseInt(selObjectColor.substr(3, 2), 16);
                let b = parseInt(selObjectColor.substr(5, 2), 16);
                SetActorColor(result.data[i].actorId, r, g, b);
                hasSelectionIds.push(result.data[i].actorId);
                if(actorTreeObj!=null){
                  //同步构件树
                  let sp = result.data[i].actorId.indexOf('_');
                  let actorId = result.data[i].actorId.substr(sp+1,result.data[i].actorId.length);
                  let node = actorTreeObj.getNodeByParam("glid",actorId, null);
                  if(node != null)
                    actorTreeObj.checkNode(node, true, true);
                }
              }

              this.taskVisible = true;
            }
          });
        } else {
          this.taskVisible = true;
        }
      },
      //表单提交后回调
      doSubmit: function () {
        this.closeTaskForm();
      },
      //表单取消后回调
      doCancel: function () {
        this.closeTaskForm();
      },
      doDelete: function () {
        this.closeTaskForm();
      },
      //关闭视图
      closeAddTaskView: function () {
        if (this.option == 0 && this.formData.id != null) {
          gantt.deleteTask(this.formData.id);
        }
        gantt.clearAll();
        gantt.load(this.loadUrl);
        //同步构件树
        if(actorTreeObj!=null){
          actorTreeObj.checkAllNodes(false);
        }
        ResetAllActor();
        hasSelectionIds = [];
        this.initMarker();
      },
      closeTaskForm: function () {
        this.taskVisible = false;
        this.closeAddTaskView();
      },
      initMarker: function () {
        clearInterval(this.auto);
        this.actors = null;
        this.time = 0;
        this.n = 0;
        //添加标记线
        this.voidStart = false;
        taskMinMaxTime({
          proId: this.proId,
          comId: null,
          status: 1,
          scheduledId: this.scheduledId
        }, this.GLOBAL.header).then(result => {
          if (result.success && result.data != null) {
            startTime = new Date(result.data.minDate);
            endTime = new Date(result.data.maxDate);
            ms = endTime.getTime() - startTime.getTime();
            markerId = gantt.addMarker({
              start_date: startTime,
              css: "status_line",
            });
            this.voidStart = true;
          }
        });
        this.actors = null;
      }
    },
    mounted() {
      this.initMarker();
      window.showAddTask = this.showAddTaskView;
      let proId = this.proId;
      let comId = null
      let status = 1;
      this.loadUrl = this.GLOBAL.businessServerPath + "/progress/searchtask?proId=" + proId + "&comId=" + comId + "&status=" + status + "&scheduledId=" + this.scheduledId;
      //初始化时间格式
      gantt.config.date_format = "%Y-%m-%d %H:%i";
      gantt.config.scale_height = 60;
      gantt.config.columns = [
        {name: "text", label: "任务名", tree: true, width: '300'},
        {name: "start_date", label: "开始时间", align: "center", width: '80'},
        {name: "end_date", label: "结束时间", align: "center", width: '80'},
        {name: "duration", label: "持续时间(天)", align: "center", width: '80'},
        {name: "add", label: ""}
      ];

      let monthScaleTemplate = function (date) {
        let dateToStr = gantt.date.date_to_str("%Y-%M");
        return dateToStr(date);
      };
      gantt.config.scales = [
        {unit: "day", step: 1, format: "%j"},
        {unit: "month", step: 1, format: monthScaleTemplate},
        {unit: "year", step: 1, format: "%Y"},
      ];
      gantt.templates.progress_text = function (start, end, task) {
        return "<span style='text-align:left;'>" + Math.round(task.progress * 100) + "% </span>";
      };
      let ins = 1;
      gantt.templates.date_grid = function(date, task){
          ins++;
          if(ins%2!=0){
            return gantt.templates.grid_date_format(gantt.date.add(date,-1,"day"));
          }else{
            return gantt.templates.grid_date_format(date);
          }

      };

      //操作事件===========================================
      onBeforeLightbox = gantt.attachEvent("onBeforeLightbox", function (id) {
        let task = gantt.getTask(id);
        showTaskEditView(task, 0);
        return false;
      });
      onTaskDblClick = gantt.attachEvent("onTaskDblClick", function (id) {
        let task = gantt.getTask(id);
        showTaskEditView(task, 1);
        return false;
      });
      updateTaskEvent = gantt.attachEvent("onAfterTaskUpdate",  (id, task) => {
        let p = {};
        p.id = id;
        p.text = task.text;
        p.startDate = task.start_date;
        p.duration = task.duration;
        p.progress = task.progress;
        p.endDate = task.end_date;
        p.option = 1
        updateTask(p, this.GLOBAL.header).then(result => {
          if (result.success) {
            gantt.clearAll();
            gantt.load(this.loadUrl);
            this.initMarker();
          }
        });
      });
      addLinkEvent = gantt.attachEvent('onAfterLinkAdd', (id, link) => {
        this.pause();
        link.proId = proId;
        link.scheduledId = this.scheduledId;
        createLink(link, this.GLOBAL.header).then(result => {
          // gantt.clearAll();
          // gantt.load(this.loadUrl);
        });
      });
      updateLinkEvent = gantt.attachEvent('onAfterLinkUpdate', (id, link) => {
        this.pause();
        link.proId = proId;
        link.scheduledId = this.scheduledId;
        updateLink(link, this.GLOBAL.header).then(result => {
          // gantt.clearAll();
          // gantt.load(this.loadUrl);
        });
      });
      delLinkEvent = gantt.attachEvent('onAfterLinkDelete', (id, link) => {
        this.pause();
        let p = {};
        p.id = id;
        delLink(p, this.GLOBAL.header).then(result => {
        });
      });
      gantt.init(this.$refs.gantt);
      gantt.load(this.loadUrl);

    },
    destroyed() {
      gantt.clearAll();
      gantt.destructor();
      gantt.detachEvent(addViewEvent);
      gantt.detachEvent(saveEvent);
      gantt.detachEvent(marketEvent);
      gantt.detachEvent(addTaskEvent);
      gantt.detachEvent(updateTaskEvent);
      gantt.detachEvent(delTaskEvent);
      gantt.detachEvent(addLinkEvent);
      gantt.detachEvent(updateLinkEvent);
      gantt.detachEvent(delLinkEvent);
      gantt.detachEvent(onTaskDblClick);
      gantt.detachEvent(onBeforeLightbox);
      gantt.detachEvent(onLoadEnd);
      clearInterval(this.auto);
    }
  }
</script>

<style>
  .p_gantt_box {
    position: relative;
    height: 90%;
    width: 100%;
    display: table;

  }

  .p_gantt_box_progress {
    position: relative;
    display: table-cell;
    height: 100%;
  }

  .p_gantt_progress {
    height: 100%
  }

  .p_gantt_bar {
    position: relative;
    height: 10%;

  }
  .p_gantt_bar input{
    margin-top: 3px;
  }
  .status_line {
    background-color: #0ca30a;
  }

  .p_gantt_section {
    position: relative;
    width: 100%;
    height: 100%;

  }

  .gantt_layout_cell ::-webkit-scrollbar { /*滚动条整体样式*/
    width: 10px; /*高宽分别对应横竖滚动条的尺寸*/
    height: 10px;
  }

  .gantt_layout_cell ::-webkit-scrollbar-thumb { /*滚动条里面小方块*/
    border-radius: 5px;
    -webkit-box-shadow: inset 0 0 5px rgba(0, 0, 0, 0.2);
    background: rgba(0, 0, 0, 0.2);
  }

  .gantt_layout_cell ::-webkit-scrollbar-track { /*滚动条里面轨道*/
    -webkit-box-shadow: inset 0 0 5px rgba(0, 0, 0, 0.2);
    border-radius: 0;
    background: rgba(0, 0, 0, 0.1);
  }

  .p_task_form {
    position: absolute;
    top: -35px;
    left: 595px;
    background: #fff;
    border: 1px solid #c9c9c9;
    z-index: 11;
  }

  .p_progress_modal {
    position: absolute;
    width: 100%;
    height: 100%;
    top: 0px;
    left: 0px;
    z-index: 10;
  }
</style>



// WEBPACK FOOTER //
// src/components/progress/Gantt.vue